<script lang="ts">
  import Modal from './shared/modal.svelte';
  import { modalComponent, setModalHash, WorkModals } from './shared/modal-store';
  import { Router } from '@roxi/routify';
  import { routes } from '../.routify/routes';
  import { onMount } from 'svelte';
  import { locale } from 'svelte-i18n';
  import { isIOS } from './shared/utils';
  import Toast from './shared/toast.svelte';

  let initialLanguageBoolean = false;

  onMount(() => {
    setMobileVh();
    checkInitialLanguage();
    handleModalOnBackEvent();
  });

  /**
   * Opens Modal on back event
   */
  function handleModalOnBackEvent() {
    window.addEventListener('popstate', (event) => {
      // Check if the user is going back and the hash is present
      // This behaviour does not work well on iOS, so we ignore it.
      if (event.state == null && window.location.hash !== '' && !isIOS()) {
        const modal = <WorkModals>window.location.hash.split('#')[1];
        setModalHash(modal);
      }
    });
  }

  window.addEventListener('resize', () => {
    setMobileVh();
  });

  function checkInitialLanguage() {
    if (initialLanguageBoolean) {
      return;
    }

    const { language } = window.navigator;

    initialLanguageBoolean = true;

    if (language.includes('pt')) {
      locale.set('pt');
      return;
    }

    locale.set('en');
  }

  /**
   * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
   */
  const setMobileVh = () => {
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };
</script>

<Router {routes} />

<Toast></Toast>

{#if $modalComponent}
  <Modal component={$modalComponent} />
{/if}

<style global lang="postcss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;

  .l-layout__sides {
    @apply w-full max-w-[70vw] xs:max-w-[64vw] sm:max-w-[60vw] md:max-w-[55vw] md2:min-w-full md2:px-[72px] lg:px-[160px] xl:px-0 xl:min-w-[unset] xl:max-w-[1248px] mx-auto;
  }

  @layer base {
    body {
      padding: 0;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      @apply text-black
        text-xxs xs:text-xs sm:text-sm md:text-md md2:text-md2 lg:text-lg xl:text-xl
        leading-6 sm:leading-8 md:leading-8 md2:leading-10 lg:leading-10 xl:leading-[3rem]
        pt-font-xxs xs:pt-font-xs sm:pt-4 md:pt-font-md xl:pt-font-lg
        pb-font-xs xs:pb-font-md md2:pb-font-lg xl:pb-font-xl;
    }

    p {
      @apply text-opaque-white  
        pt-font-xxs xl:pt-font-xs
        pb-font-xs xl:pb-font-md
        leading-6 xl:leading-8
        text-base md:text-xxs lg:text-base xl:text-xs;
    }
  }

  .u-highlight--none {
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  :root {
    --border-gray: #bfbfbf;
  }

  .c-flipper-number {
    display: inline-block;
    width: 2.4em;
    height: 1.55em;
    background-image: url('../images/number-01.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    vertical-align: middle;

    opacity: 1;
  }
</style>
